import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";

import SellerIdentityInfo from "./sellerIdentityInfo";
import { Address, DocumentUrl } from "../../../models/loan.model";
import DetailInfoComponentThumbnail from "../../../components/thumbnail/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: Address;
  documentList: DocumentUrl[];
  withoutDoc: boolean;
}
function _SellerDocument({ data, documentList, withoutDoc }: SchemaInfoModel) {
  const sections: SectionModel[] = [
    { dataKey: "fullName", rowCol: 3, title: " نام و نام خانوادگی" },
    { dataKey: "nationalCode", rowCol: 3, title: " کدملی" },
    { dataKey: "mobileNumber", rowCol: 3, title: " شماره موبایل" },
    { dataKey: "shenasnamehNumber", rowCol: 3, title: "شماره شناسنامه" },
    { dataKey: "fatherName", rowCol: 3, title: "نام پدر" },
    { dataKey: "birthdate_Persian", rowCol: 3, title: "تاریخ تولد" },
    // { dataKey: "postalCode", rowCol: 3, title: "کدپستی" },
  ];
  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={[]}
      height={"20vh"}
      addressByInquiry={true}
      showFooter={false}
      showDoc={withoutDoc}
      isGuarantor={true}
    />
  );
}

export default function SellerDocument(props: any) {
  let documentUrlList = [] as DocumentUrl[];
  documentUrlList = props.data?.documentUrls;
  const child = (
    <>
      <_SellerDocument
        data={props.data}
        documentList={documentUrlList}
        withoutDoc={props.withoutDoc}
      />
    </>
  );

  return (
    <>
      <DivisionCmp
        child={child}
        title={props.title ? props.title : "مدارک هویتی فروشنده"}
      />
      <SellerIdentityInfo data={props?.data?.identityDocuments!} />
    </>
  );
}
